export const PBB_PHONE_NUMBER_MASK =
  '(000) 000 0000||+0 (000) 000 0000||+00 (000) 000 0000||+000 (000) 000 0000||+000 (000) 000 0000 0000000000';
export const PHONE_NUMBER_BE_MASK_MAP = new Map<number, string>([
  [11, '+0-000-000-0000'],
  [12, '+00-000-000-0000'],
  [13, '+000-000-000-0000'],
]);
